// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fieldset {
  border: 1px solid #ddd;
  font-size: 14px;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-width: unset;
  max-width: 100%;
  gap: 4px;
}
fieldset legend {
  font-weight: 500;
  color: #6ba7a8;
  padding: 0 8px;
}
fieldset .styles_tagWrapper__76ozq {
  display: flex;
  flex-direction: row;
  gap: 32px;
  flex-wrap: wrap;
}
fieldset .styles_tagWrapper__76ozq .styles_singleTag__bOSpo {
  display: flex;
  align-items: center;
  gap: 4px;
}
fieldset .styles_tagWrapper__76ozq .styles_singleTag__bOSpo input {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  font-size: 14px;
  transition: border 0.3s;
  resize: none;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptUploader/TagOptions/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AACF;AAAE;EACE,gBAAA;EACA,cAAA;EACA,cAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAEJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAEN;AAAM;EACE,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAER","sourcesContent":["fieldset {\n  border: 1px solid #ddd;\n  font-size: 14px;\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  min-width: unset;\n  max-width: 100%;\n  gap: 4px;\n  legend {\n    font-weight: 500;\n    color: #6ba7a8;\n    padding: 0 8px;\n  }\n  .tagWrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 32px;\n    flex-wrap: wrap;\n\n    .singleTag {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      input {\n        padding: 6px 12px;\n        border: 1px solid #ddd;\n        border-radius: 0.5rem;\n        font-size: 14px;\n        transition: border 0.3s;\n        resize: none;\n        width: auto;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagWrapper": `styles_tagWrapper__76ozq`,
	"singleTag": `styles_singleTag__bOSpo`
};
export default ___CSS_LOADER_EXPORT___;
